import React from 'react';
import moon from '../../res/moon.png';
import './albumsp.css';
import { Link } from 'react-router-dom';
import { ALBUM_POSTS, options } from '../../graphql/Queries';
import useQueryPosts from '../../hooks/useQueryPosts';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const TopAlbums = () => {
  const { posts, error} = useQueryPosts({query: ALBUM_POSTS, main: true});

  if(error) return <h2>{error}</h2>

  return (
    <TopAlbumsContainer>
      <Link to={'/albums'}>
        <HeaderTitle>ALBUM REVIEWS</HeaderTitle>
      </Link>

      {posts.length > 0 && 
      <main>
        <Link to={`/albums/${posts[0].slug}`}>
          <HighlightAlbum>
            <img src={posts[0].coverPhoto.url} alt='album cover'/>
            <div>
              <h2>{posts[0].title}</h2>
              <p>{posts[0].artist}</p>
              <p>{new Date(posts[0].datePublished).toLocaleDateString('en-US', options)}</p>
            </div>
          </HighlightAlbum>
        </Link>

        <aside>
          <Link to={`/albums/${posts[1].slug}`}>
            <div>
              <img src={posts[1].coverPhoto.url} alt='album cover'/>
              <div>
                <h2>{posts[1].title}</h2>
                <p>{posts[1].artist}</p>
                <p>{new Date(posts[1].datePublished).toLocaleDateString('en-US', options)}</p>
              </div>
            </div>
          </ Link>

          <Link to={`/albums/${posts[2].slug}`}>
            <div>
              <img src={posts[2].coverPhoto.url} alt='album cover'/>
              <div>
                <h2>{posts[2].title}</h2>
                <p>{posts[2].artist}</p>
                <p>{new Date(posts[2].datePublished).toLocaleDateString('en-US', options)}</p>
              </div>
            </div>

          </Link>

          <Link to={`/albums/${posts[3].slug}`}>
            <div>
              <img src={posts[3].coverPhoto.url} alt='album cover'/>
              <div>
                <h2>{posts[3].title}</h2>
                <p>{posts[3].artist}</p>
                <p>{new Date(posts[3].datePublished).toLocaleDateString('en-US', options)}</p>
              </div>
            </div>
          </Link>
          
        </aside>
      </main>} 
      
    </TopAlbumsContainer>
  )
}

const TopAlbumsContainer = styled.div`
  background-color: black;
  display: flex;
  flex-direction: column;
  position: relative;
  padding-top: 40px;
  padding-bottom: 40px;
  align-items: center;

  main {
    display: flex;
    align-items: self-start;
    justify-content: center;
    z-index: 0;
  }
`

const semi_circle_animation = keyframes`
  0%,
  100% {
    transform: translateX(-5vw) translateY(0);
  }
  10% {
    transform: translateX(10vw) translateY(-40vh);
  }
  20% {
    transform: translateX(35vw) translateY(-70vh);
  }
  30% {
    transform: translateX(60vw) translateY(-70vh);
  }
  40% {
    transform: translateX(85vw) translateY(-40vh);
  }
  50% {
    transform: translateX(105vw) translateY(0);
  }
  60% {
    transform: translateX(85vw) translateY(-40vh);
  }
  70% {
    transform: translateX(60vw) translateY(-70vh);
  }
  80% {
    transform: translateX(35vw) translateY(-70vh);
  }
  90% {
    transform: translateX(10vw) translateY(-40vh);
  }
}
`
const flipped_semi_circle_animation = keyframes`
  0%,
  100% {
    transform: translateX(105vw) translateY(0);
  }
  10% {
    transform: translateX(85vw) translateY(40vh);
  }
  20% {
    transform: translateX(60vw) translateY(70vh);
  }
  30% {
    transform: translateX(35vw) translateY(70vh);
  }
  40% {
    transform: translateX(10vw) translateY(40vh);
  }
  50% {
    transform: translateX(-10vw) translateY(0);
  }
  60% {
    transform: translateX(10vw) translateY(40vh);
  }
  70% {
    transform: translateX(35vw) translateY(70vh);
  }
  80% {
    transform: translateX(60vw) translateY(70vh);
  }
  90% {
    transform: translateX(85vw) translateY(40vh);
  }
}
`

const HeaderTitle = styled.h1`
  font-size: 40px;
  font-family: Super Brigade;
  color: white;
  text-align: center;
  padding-top: 60px;
  margin-bottom: 100px;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
  transition: transform 500ms;
  cursor: pointer;
  :hover {
    transform: scale(1.05);
  }
`

const HighlightAlbum = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 45px;
  margin-left: 40px;
  padding-left: 40px;
  cursor: pointer;
  transition: transform 500ms;
`

export default TopAlbums
